import Vue from 'vue';
import Vuex from 'vuex';
import { IAuthState } from './modules/Auth';
import { IWorkHours } from './modules/WorkHours';

Vue.use(Vuex);

export interface IRootState {
  auth: IAuthState;
  workHours: IWorkHours;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
